import { render, staticRenderFns } from "./course_list.vue?vue&type=template&id=2fa573f4&scoped=true&"
import script from "./course_list.vue?vue&type=script&lang=js&"
export * from "./course_list.vue?vue&type=script&lang=js&"
import style0 from "./course_list.vue?vue&type=style&index=0&id=2fa573f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa573f4",
  null
  
)

export default component.exports